import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import CustomIcon from '@/components/CustomIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(CustomIcon.name, CustomIcon)
